import clsx from 'clsx';

import type { Adaptive } from '../types/Adaptive';
import type { TextSize } from '../types/TextSize';

export function composeTextSizeClasses(size: Adaptive<TextSize>): string {
    if (typeof size === 'object') {
        return clsx(
            size.base && `text-${size.base}`,
            size.sm && `sm:text-${size.sm}`,
            size.md && `md:text-${size.md}`,
            size.lg && `lg:text-${size.lg}`,
            size.xl && `xl:text-${size.xl}`,
            size['2xl'] && `2xl:text-${size['2xl']}`
        );
    }

    return `text-${size}`;
}
